import { store } from '../../store'
import { httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get ({ commit, dispatch }, payload) {
    let url = 'api/areas-users'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getByUser ({ commit, dispatch }, payload) {
    let url = 'api/user-areas/' + payload.event.user.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetByUser', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({ commit, dispatch }, payload) {
    let url = 'api/areas-users'
    let params = {
      'user_id': payload.user.id,
      'gst_area_id': payload.area.id
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  delete ({ commit, dispatch }, payload) {
    let url = 'api/areas-users/' + payload.event.user.id + '/' + payload.event.area.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from areasUsers
  onGet (state, payload) {
    let areasUsers = payload.response.data.data
    payload.event.context.areasUsers = areasUsers
  },
  // Set the data obtained from areasUsers
  onGetByUser (state, payload) {
    let userArea = payload.response.data.data[0]
    payload.event.context.editedItem.area = userArea.area
    payload.event.context.editedItem.area_original = Object.assign({}, userArea.area)
  },
  // Add the data to areasUsers
  onPost (state, payload) {
    // payload.event.context.showNotification(payload.response, 'success')
    // payload.event.context.close()
    payload.event.context.put()
  },
  // Removes the data from areasUsers
  onDelete (state, payload) {
    if (payload.event.newArea) {
      let user = payload.event.user
      let area = payload.event.newArea
      this.dispatch('areasUsers/post', { event: payload.event, user: user, area: area })
    }
  },
  // Shows a error message
  onError (state, payload) {
    payload.event.context.loading = false
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response.data.message, 'error', -1)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/areasUsers.js